/* sc-cart-expire-timer.js — cart drawer expiry countdown that SURVIVES
 * section re-renders (vendor <countdown-timer> restarts at 10:00 on every
 * quantity change because the drawer body innerHTML is swapped).
 *
 * Same mechanism as the approved reference implementation (
 * initCartCheckoutCountdown): the deadline lives in sessionStorage, every
 * paint reads it fresh, and the display repaints IMMEDIATELY after any DOM
 * swap — a MutationObserver + requestAnimationFrame repaint runs before the
 * browser paints the re-rendered "10:00" placeholder, so no flash. When the
 * countdown reaches zero the banner swaps to the ended message and the
 * stored deadline clears; the next render starts a fresh window (reference
 * parity).
 */
(function () {
  'use strict';

  var KEY = 'sc-cart-expire-deadline';
  var DEFAULT_DURATION = 600; // seconds
  var ENDED_MESSAGE = 'Forgot one final step? Place your order now and make the payment right away!';

  var memoryDeadline = 0; // fallback when sessionStorage is blocked

  function readStored() {
    try {
      return parseInt(sessionStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      return memoryDeadline;
    }
  }

  function writeStored(value) {
    memoryDeadline = value;
    try { sessionStorage.setItem(KEY, String(value)); } catch (e) { /* noop */ }
  }

  function clearStored() {
    memoryDeadline = 0;
    try { sessionStorage.removeItem(KEY); } catch (e) { /* noop */ }
  }

  /* Read and renew are deliberately SEPARATE (reference parity): a fresh
     window may only start when no deadline exists — never as a side effect
     of reading an expired one, or the ended state could never appear. */
  function ensureDeadline(durationSeconds) {
    var stored = readStored();
    if (stored) return stored;
    var deadline = Date.now() + durationSeconds * 1000;
    writeStored(deadline);
    return deadline;
  }

  function format(msRemaining) {
    var total = Math.max(0, Math.floor(msRemaining / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return (m < 10 ? '0' + m : '' + m) + ':' + (s < 10 ? '0' + s : '' + s);
  }

  function markEnded(banner) {
    if (!banner || banner.dataset.scExpired === '1') return;
    banner.dataset.scExpired = '1';
    banner.textContent = '';
    var span = document.createElement('span');
    span.textContent = ENDED_MESSAGE;
    banner.appendChild(span);
  }

  function tick() {
    var nodes = document.querySelectorAll('.sc-cart-expire-timer');
    if (!nodes.length) return;
    var duration = parseInt(nodes[0].getAttribute('data-duration'), 10) || DEFAULT_DURATION;
    var remaining = ensureDeadline(duration) - Date.now();

    if (remaining <= 0) {
      // Swap every banner to the ended message; the cleared deadline means
      // the NEXT render (not this one) starts a fresh window.
      for (var j = 0; j < nodes.length; j++) {
        markEnded(nodes[j].closest('.sc-cart-drawer-urgency'));
      }
      clearStored();
      return;
    }

    for (var i = 0; i < nodes.length; i++) {
      var text = format(remaining);
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  /* Repaint before the next frame whenever the drawer (or anything else)
     re-renders — the static "10:00" placeholder never reaches the screen. */
  var scheduled = false;
  function scheduleTick() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      tick();
    });
  }

  new MutationObserver(scheduleTick).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  tick();
  setInterval(tick, 1000);
})();
